import "react";
import { Checkbox, DinnerTable } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
// src/modules/Users/shared/UserAuthSessionsTable/TableHeadRow.tsx
function UserAuthSessionsTableHeadRow({ allRowsSelected, onSelectAllRows, showUserName }) {
	return /* @__PURE__ */ jsx(DinnerTable.Header, { children: /* @__PURE__ */ jsxs(DinnerTable.Row, {
		isHeader: true,
		children: [
			/* @__PURE__ */ jsx(DinnerTable.Cell, {
				isHeader: true,
				children: /* @__PURE__ */ jsx("div", {
					className: "flex justify-center self-center",
					children: /* @__PURE__ */ jsx(Checkbox, {
						active: allRowsSelected,
						onChangeValue: () => onSelectAllRows()
					})
				})
			}),
			showUserName && /* @__PURE__ */ jsx(DinnerTable.Cell, {
				isHeader: true,
				children: "Name"
			}),
			/* @__PURE__ */ jsx(DinnerTable.Cell, {
				isHeader: true,
				children: "Device"
			}),
			/* @__PURE__ */ jsx(DinnerTable.Cell, {
				isHeader: true,
				children: "Activity"
			}),
			/* @__PURE__ */ jsx(DinnerTable.Cell, {
				isHeader: true,
				children: "Created / Expires"
			}),
			/* @__PURE__ */ jsx(DinnerTable.Cell, {
				isHeader: true,
				children: "Apps"
			}),
			/* @__PURE__ */ jsx(DinnerTable.Cell, {
				isHeader: true,
				children: "Permissions"
			})
		]
	}) });
}
export { UserAuthSessionsTableHeadRow };

//# sourceMappingURL=TableHeadRow.js.map